import CheckoutRoutes from './checkout.routes';

export default CheckoutRoutes;
